import React from 'react';
import {
	Modal,
	FormGroup,
	FormControl,
	HelpBlock,
	ButtonGroup,
	Button,
} from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import '../../../public/css/passwordRecovery.css';
import { connect } from 'react-redux';
import { getDataName } from '../../dashboard/reducer';
import { getTokenId, getJWT } from '../../../redux/reducers/authenticationReducers';
import { resetPassword } from '../../../api/api';
import { get } from 'lodash';
import defaultMsg from '../../../translations/lang/en-US.json';

const INVALID_EMAIL = 'INVALID_EMAIL',
	EMAIL_DOES_NOT_EXIST = 'EMAIL_DOES_NOT_EXIST';
class PasswordRecovery extends React.Component {
	initialState() {
		return {
			email: '',
			show: true,
			submitError: false,
			formError: '',
			errorType: 'Valid',
			passwordRecoveryLinkSent: false,
			requestingForReset: false,
		};
	}

	constructor(props) {
		super(props);
		this.state = this.initialState();
		this.getValidationState = this.getValidationState.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
		this.isValidEmail = this.isValidEmail.bind(this);
		this.close = this.close.bind(this);
	}

	handleChange(e) {
		this.setState({
			email: e.target.value,
			submitError: false,
			formError: '',
		});
	}

	isValidEmail() {
		return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
			this.state.email
		);
	}

	getValidationState() {
		const email = this.state.email;
		const isValidEmailString = /[a-z0-9._%+-@\.]$/;
		if (this.isValidEmail()) {
			return 'success';
		} else if (isValidEmailString.test(email)) {
			return 'warning';
		} else if (email.length > 0 && !this.isValidEmail()) {
			return 'error';
		}
		return null;
	}

	handleFormSubmit() {
		if (this.isValidEmail()) {
			const { dataname, tokenId, jwt } = this.props;
			const { email } = this.state;
			this.setState({
				requestingForReset: true,
			});
			resetPassword({
				email,
				dataname,
				tokenId,
				jwt,
			}).then(response => {
				const apiResponse = get(response, 'data.DataResponse', {});
				if (apiResponse.Status === 'S') {
					this.setState({
						passwordRecoveryLinkSent: true,
					});
				} else {
					this.setState({
						submitError: true,
						formError: EMAIL_DOES_NOT_EXIST,
					});
				}
				this.setState({
					requestingForReset: false,
				});
			});
		} else {
			this.setState({
				submitError: true,
				formError: INVALID_EMAIL,
				requestingForReset: false,
			});
		}
	}

	close() {
		this.props.onClose();
	}

	render() {
		return (
			<Modal show={this.state.show} onHide={this.close}>
				<Modal.Header closeButton />
				<Modal.Body className="login-container">
					<h4 className="modal-title olo-client-theme-color text-center">
						<FormattedMessage
							id="forgotPassword"
							defaultMessage={defaultMsg.forgotPassword}
						/>
					</h4>
					{this.state.passwordRecoveryLinkSent ? (
						<div>
							<div className="font-small text-center login-help-block">
								<FormattedMessage
									id="passwordRecoveryLinkSent"
									defaultMessage={defaultMsg.passwordRecoveryLinkSent}
									values={{
										email: this.state.email,
									}}
								/>
							</div>
							<ButtonGroup justified>
								<Button
									onClick={this.close}
									className="full-width olo-client-theme-background olo-client-theme-border olo-client-theme-color-white font-medium"
									bsSize="large"
								>
									<FormattedMessage
										id="closeButton"
										defaultMessage={defaultMsg.closeButton}
									/>
								</Button>
							</ButtonGroup>
						</div>
					) : (
						<div>
							<div className="font-small text-center login-help-block">
								<FormattedMessage
									id="forgotPasswordRequestForEmail"
									defaultMessage={defaultMsg.forgotPasswordRequestForEmail}
								/>
							</div>
							<FormGroup
								controlId="passwordRecoveryInputs"
								validationState={
									this.state.submitError
										? 'error'
										: this.getValidationState()
								}
								bsSize="large"
							>
								<FormControl
									type="text"
									value={this.state.email}
									placeholder={this.props.intl.formatMessage({
										id: 'inputEmail',
										defaultMessage: defaultMsg.inputEmail
									})}
									onChange={this.handleChange}
								/>
								<FormControl.Feedback />
								{this.state.submitError &&
								this.state.formError === INVALID_EMAIL ? (
									<HelpBlock className="font-small">
										<FormattedMessage
											id="invalidEmailMessage"
											defaultMessage={defaultMsg.invalidEmailMessage}
										/>
									</HelpBlock>
								) : null}
								{this.state.submitError &&
								this.state.formError ===
									EMAIL_DOES_NOT_EXIST ? (
									<HelpBlock className="font-small">
										<FormattedMessage
											id="emailDoesNotExistMessage"
											defaultMessage={defaultMsg.emailDoesNotExistMessage}
										/>
									</HelpBlock>
								) : null}
							</FormGroup>
							<ButtonGroup justified>
								<Button
									onClick={
										!this.state.requestingForReset
											? this.handleFormSubmit
											: null
									}
									className="full-width olo-client-theme-background olo-client-theme-border olo-client-theme-color-white font-medium"
									bsSize="large"
								>
									{this.state.requestingForReset ? (
										<FormattedMessage
											id="submiting"
											defaultMessage={defaultMsg.submiting}
										/>
									) : (
										<FormattedMessage
											id="submitButton"
											defaultMessage={defaultMsg.submitButton}
										/>
									)}
								</Button>
							</ButtonGroup>
						</div>
					)}
				</Modal.Body>
			</Modal>
		);
	}
}

function mapStateToProps(state) {
	return {
		dataname: getDataName(state),
		tokenId: getTokenId(state),
		jwt: getJWT(state),
	};
}

export default connect(mapStateToProps)(injectIntl(PasswordRecovery));



// WEBPACK FOOTER //
// ./src/views/auth/passwordreset/PasswordRecovery.jsx